// extracted by mini-css-extract-plugin
export default {"container":"DescriptionDialog_container__OkqAz"};